/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_VALUE_LISTS,
  GET_VALUE_LISTS_SUCCESS,
  GET_VALUE_LISTS_ERROR,
  CLEAR_VALUE_LISTS,
  SET_BACK_TO_VALUE_LISTS,
} from 'src/actions/valueListsActions';

const backToValueLists = {
  active: false,
  comeBack: false,
  search: '',
  scopeFilter: 'All',
  listType: 'smartFieldOptions',
  sort: null,
  scrollTop: 0,
  backToId: null,
};

const initialState = {
  lists: [],
  companyName: null,
  listType: 'smartFieldOptions',
  loading: false,
  loaded: false,
  backToValueLists,
};

const valueListsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_VALUE_LISTS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_VALUE_LISTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.lists = payload?.lists || [];
        draft.companyName = payload?.companyName || null;
        draft.listType = payload?.listType || 'smartFieldOptions';
        draft.loading = false;
        draft.loaded = true;
      });
    }

    case GET_VALUE_LISTS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = false;
      });
    }

    case CLEAR_VALUE_LISTS: {
      return produce(state, (draft) => {
        draft.lists = [];
        draft.loaded = false;
      });
    }

    case SET_BACK_TO_VALUE_LISTS: {
      return produce(state, (draft) => {
        draft.backToValueLists = payload === false
          ? { ...backToValueLists }
          : { ...draft.backToValueLists, ...payload };
      });
    }

    default: {
      return state;
    }
  }
};

export default valueListsReducer;
